// extracted by mini-css-extract-plugin
export var closeButton = "_mt-2";
export var closeButtonIcon = "_mt-3";
export var lightboxContent = "_mt-1";
export var lightboxOverlay = "_mt-0";